module.exports = __webpack_public_path__ + "static/bitpayper-b29e352b650d6d331f9c2b21d2b1e01a.png";